import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';

@JsonObject('model.time_card.TimeCard')
export class RecordCard extends AbstractModel {

  @JsonProperty(Number, 'id')
  id: number;

  @JsonProperty(String, 'start')
  start?: string;

  @JsonProperty(String, 'finish')
  finish?: string;

  @JsonProperty(Number, 'dayTotal')
  dayTotal?: number;

  @JsonProperty(Number, 'weekTotal')
  weekTotal?: number;

  @JsonProperty(Number, 'duration')
  duration?: number;

  @JsonProperty(Number, 'projectId')
  projectId?: number;

  @JsonProperty(String, 'projectName')
  projectName?: string;

  @JsonProperty(String, 'type')
  type?: string;

  @JsonProperty(Boolean, 'punchOutOutsideShop')
  punchOutOutsideShop?: boolean;

  @JsonProperty(Boolean, 'punchInOutsideShop')
  punchInOutsideShop?: boolean;

  @JsonProperty(String, 'closeStatus')
  closeStatus?: string;

  @JsonProperty(Number, 'punchInLat')
  punchInLat?: number;

  @JsonProperty(Number, 'punchInLong')
  punchInLong?: number;

  @JsonProperty(Number, 'punchOutLat')
  punchOutLat?: number;

  @JsonProperty(Number, 'punchOutLong')
  punchOutLong?: number;

}
